__turbopack_context__.v({
  "collectionsWorkspace": "style-module-scss-module__okVF0q__collectionsWorkspace",
  "desktopTopBar": "style-module-scss-module__okVF0q__desktopTopBar",
  "destinationPane": "style-module-scss-module__okVF0q__destinationPane",
  "expChrome": "style-module-scss-module__okVF0q__expChrome",
  "listingsFullScreen": "style-module-scss-module__okVF0q__listingsFullScreen",
  "listingsPane": "style-module-scss-module__okVF0q__listingsPane",
  "listingsPaneHidden": "style-module-scss-module__okVF0q__listingsPaneHidden",
  "main": "style-module-scss-module__okVF0q__main",
  "mapCell": "style-module-scss-module__okVF0q__mapCell",
  "mapFullscreen": "style-module-scss-module__okVF0q__mapFullscreen",
  "mapFullscreenViewToggle": "style-module-scss-module__okVF0q__mapFullscreenViewToggle",
  "mobileActionBar": "style-module-scss-module__okVF0q__mobileActionBar",
  "mobileListView": "style-module-scss-module__okVF0q__mobileListView",
  "mobileTopBar": "style-module-scss-module__okVF0q__mobileTopBar",
  "mobileViewToggle": "style-module-scss-module__okVF0q__mobileViewToggle",
  "mobileViewToggleIcon": "style-module-scss-module__okVF0q__mobileViewToggleIcon",
  "provinceFullWidth": "style-module-scss-module__okVF0q__provinceFullWidth",
  "rail": "style-module-scss-module__okVF0q__rail",
  "removeBoundary": "style-module-scss-module__okVF0q__removeBoundary",
  "root": "style-module-scss-module__okVF0q__root",
  "workspace": "style-module-scss-module__okVF0q__workspace",
  "workspaceParked": "style-module-scss-module__okVF0q__workspaceParked",
});
